module.exports = __webpack_public_path__ + "img/6.73479896.jpg";